module.exports = __webpack_public_path__ + "static/media/DSC08716.695bd0a4.jpg";